"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ReviewFormSnapshot () {
        return ReviewFormSnapshot;
    },
    get ReviewQuestionSnapshot () {
        return ReviewQuestionSnapshot;
    },
    get ReviewWorkflowSnapshot () {
        return ReviewWorkflowSnapshot;
    },
    get SurveySnapshot () {
        return SurveySnapshot;
    },
    get TEMPLATE_LIBRARY_ENTRY_TYPES () {
        return TEMPLATE_LIBRARY_ENTRY_TYPES;
    },
    get TemplateLibraryEntryModel () {
        return TemplateLibraryEntryModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const objectId = _zod.z.instanceof(_bson.ObjectId);
const ReviewQuestionSnapshot = _zod.z.object({
    _id: objectId,
    type: _zod.z.string(),
    text: _zod.z.string().optional(),
    subtitle: _zod.z.string().optional(),
    options: _zod.z.array(_zod.z.unknown()).optional(),
    questions: _zod.z.array(_zod.z.object({
        id: objectId
    }).passthrough()).optional()
}).passthrough();
const ReviewFormSnapshot = _zod.z.object({
    _id: objectId,
    base_id: objectId,
    name: _zod.z.string(),
    questions: _zod.z.array(objectId),
    goal_creation: _zod.z.boolean().optional(),
    goal_discussion: _zod.z.boolean().optional()
}).passthrough();
const ReviewWorkflowSnapshot = _zod.z.object({
    name: _zod.z.string(),
    // id is a workflow-internal tracking id that may not be set on every form-entry;
    // the clone helper handles its absence (see Task 8 clone helpers).
    forms: _zod.z.array(_zod.z.object({
        id: objectId.optional(),
        form_id: objectId
    }).passthrough())
}).passthrough();
const SurveySnapshot = _zod.z.object({
    _id: objectId,
    name: _zod.z.string(),
    description: _zod.z.string().optional(),
    questions: _zod.z.array(_zod.z.object({
        _id: objectId
    }).passthrough())
}).passthrough();
// --- Per-type payloads ---
const ReviewWorkflowPayloadSchema = _zod.z.object({
    workflow: ReviewWorkflowSnapshot,
    forms: _zod.z.array(ReviewFormSnapshot),
    questions: _zod.z.array(ReviewQuestionSnapshot)
});
const ReviewFormPayloadSchema = _zod.z.object({
    form: ReviewFormSnapshot,
    questions: _zod.z.array(ReviewQuestionSnapshot)
});
const SurveyPayloadSchema = _zod.z.object({
    survey: SurveySnapshot
});
const PdfGuidePayloadSchema = _zod.z.object({
    s3_source_key: _zod.z.string(),
    filename: _zod.z.string(),
    content_type: _zod.z.string()
});
// --- Discriminated entry ---
const Base = _zod.z.object({
    _id: objectId,
    name: _zod.z.string(),
    description: _zod.z.string(),
    tags: _zod.z.array(_zod.z.string()).default([]),
    version: _zod.z.number().int().default(1),
    created_at: _zod.z.date(),
    updated_at: _zod.z.date()
});
const TemplateLibraryEntryModel = _zod.z.discriminatedUnion("type", [
    Base.extend({
        type: _zod.z.literal("review_workflow"),
        payload: ReviewWorkflowPayloadSchema
    }),
    Base.extend({
        type: _zod.z.literal("review_form"),
        payload: ReviewFormPayloadSchema
    }),
    Base.extend({
        type: _zod.z.literal("survey"),
        payload: SurveyPayloadSchema
    }),
    Base.extend({
        type: _zod.z.literal("pdf_guide"),
        payload: PdfGuidePayloadSchema
    })
]);
const TEMPLATE_LIBRARY_ENTRY_TYPES = [
    "review_workflow",
    "review_form",
    "survey",
    "pdf_guide"
];
